import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { configGetCountry } from 'common/helper/config/get-country';
import { GoogleRecaptchaViewStoreFactory } from 'common/module/google/recaptcha/view-store.factory';
import { LeadEmailFormStatechart } from 'common/module/lead/email/form/statechart';
import { StatechartStoreFactory } from 'common/module/statechart/store.factory';
import { CountryStoreService } from 'common/service/country-store/service';
import { LeadEmailFormContactService } from 'common/service/lead-email-form-contact/service';
import { StatsService } from 'common/service/stats/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

import { LeadEmailFormViewStore } from './view-store';

export function LeadEmailFormViewStoreFactory(): LeadEmailFormViewStore {
  const statechartStore = StatechartStoreFactory();

  statechartStore.initialize({
    statechart: LeadEmailFormStatechart,
  });

  return new LeadEmailFormViewStore(
    EventEmitterFactory(),
    GoogleRecaptchaViewStoreFactory(),
    configGetCountry(),
    statechartStore,
    UserAuthenticationService(),
    StatsService(),
    LeadEmailFormContactService(),
    CountryStoreService()
  );
}
